var map = {
	"./arrow_right.svg": 1189,
	"./bag.svg": 1191,
	"./caret_down.svg": 1192,
	"./chevron_down.svg": 1193,
	"./chevron_down_small.svg": 1194,
	"./chevron_left.svg": 1195,
	"./chevron_right.svg": 1196,
	"./chevron_up.svg": 1197,
	"./chevron_up_small.svg": 1198,
	"./close.svg": 1199,
	"./heart.svg": 1200,
	"./info-filled.svg": 1201,
	"./search-no-results.svg": 1202,
	"./search.svg": 1203,
	"./social-logo/apple.svg": 1204,
	"./social-logo/facebook.svg": 1205,
	"./social-logo/google.svg": 1206,
	"./stone-shape/asscher.svg": 1207,
	"./stone-shape/baguette.svg": 1208,
	"./stone-shape/cushion.svg": 1209,
	"./stone-shape/emerald.svg": 1210,
	"./stone-shape/heart.svg": 1211,
	"./stone-shape/marquise.svg": 1212,
	"./stone-shape/oval.svg": 1213,
	"./stone-shape/pear.svg": 1214,
	"./stone-shape/princess.svg": 1215,
	"./stone-shape/radiant.svg": 1216,
	"./stone-shape/round.svg": 1217,
	"./stone-shape/tapered-baguette.svg": 1218,
	"./stone-shape/triangle.svg": 1219,
	"./stone-shape/trillion.svg": 1220,
	"./tag.svg": 1221,
	"./truck.svg": 1222,
	"./user.svg": 1223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1188;